import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import ConnUrls from '../../Connections/ConnectURL';
import { MasterContext, OrderContext } from '../../ContextApi/context';
import OrderFunctions from '../../OrderSettings/OrderFunctions';
import BigPopUpMsg from '../BigPopUpMsg';
import PopUpMsg from '../PopUpMsg';
import AppDownloadPromo from './AppDownloadPromo';



const TAKE_Confirmd = (props) => {
    const [master] = useContext(MasterContext);
    const [order, setOrder] = useContext(OrderContext);

    const [CorntOrdr] = useState(() =>
        JSON.parse(JSON.stringify(props.order?.ordr || props.order))
    );

    useEffect(() => {

    }, [])


    const getPayText = (payt, approvNum) => {
        if (payt === "2") return "תשלום במזומן";
        if (approvNum === "0110") return "שולם בקרדיטים";
        if (approvNum) return "מספר אישור עסקה: " + approvNum;
        return "חיוב לא בוצע";
    };

    // CorntOrdr יכול להגיע כ-DTO שטוח (מסלול iframe/ThankPage, עם creditCrdApprov
    // ב-root) או כמסמך DB גולמי (מסלול תשלום בטוקן/כרטיס שמור - payByToken -
    // שבו הנתון נמצא רק ב-tranzactionInfo[0]) - צריך fallback לשני המקרים.
    const approvalNumber = CorntOrdr.tranzactionInfo?.[0]?.creditCrdApprov ?? CorntOrdr.creditCrdApprov;

    return (
        <PopUpMsg Title={["ההזמנה בוצעה"]}
            nosnippet={true}
            ContentText={[{ txt: "המסעדה מתחילה להכין את ההזמנה.", css: "" }
                , { txt: `ניתן יהיה להגיע לאסוף בערך בעוד ${CorntOrdr.OrderTimes} דקות`, css: "" }
                , { txt: `מספר הזמנה: ${CorntOrdr.orderNUM}`, css: "" }
                , { txt: getPayText(CorntOrdr.payt, approvalNumber), css: "" }
            ]}
            inLabel={""}
            BottomTitle={["בתאבון!"]}
            bottomExtra={<AppDownloadPromo />}
            topImg={`${ConnUrls.media(master.orderApprovImg)}`}
            cssStyl={"approveMsgPopup"}
            okClick={() => { setOrder(OrderFunctions.clearOrd()); props.okClick() }}
            errorMsg={""} />
    )
}




export default TAKE_Confirmd